import {
  Snackbar,
} from "@material-ui/core";

import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { TextField } from "@material-ui/core";
import PackService from "../../services/PackService";
import UtilsFormule from "../../utils/UtilsFormule";




function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddPackFactureModel = ({ selected, setSelected, setOnAddPack, listProducts, idWarehouse,idWarehousePrice, setProductTableData }) => {

  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [namePack, setNamePack] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [idLot, setIdLot] = useState(0);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [tauxChange, setTauxChange] = useState(0);
  const [modeProduct, setModeProduct] = useState(null);
  const [listOfProducts, setListOfProducts] = useState([]);
  const [finalProductTableData, setFinalProductTableData] = useState([]);


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };


  useEffect(() => {
    console.log("selected", selected);
    console.log("listProducts", listProducts);
    const updatedListContains = listProducts.filter(item => selected.includes(item.idProduct));
    setListOfProducts(updatedListContains);
    // selected.map((row) => {

    //   setListOfProducts((previoustate) => [...previoustate,
    //   listProducts.filter((item) => item.idProduct === row)]
    //   );

    // })
    const updatedList = listProducts.filter(item => !selected.includes(item.idProduct));

    setFinalProductTableData(updatedList);
    console.log("listOfProducts", listOfProducts);

  }, [])
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };



  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddPack(false);
  };

  const onAddBrand = () => {
    let packAddModel = {
      idUser: getCurrentUserId(),
      namePack: namePack,
      idWarehouse: idWarehouse,
      idWarehousePrice:idWarehousePrice,
      dateDebut: startDate,
      dateFin: endDate,
      productPackModels: listOfProducts,
    };


    console.log(JSON.stringify(packAddModel))
    console.log("finalProductTableData", finalProductTableData)


    setProductTableData(finalProductTableData);

    PackService.addNewPackRegroupement(packAddModel).then((result) => {
      console.log("result", result);
      if (result.data["success"]) {
        let response = UtilsFormule.CalculatePromotionProductPurchase(
          promotionPercentage,
          promotionType,
          result.data.salesprice.initialSellingPrice,
          1,
          result.data.success.tva
        );
        let promotionAmountOrPersentage = response[0];
        let sellingPrice = response[1];
        let promotionpercent = response[2];
        let ttPrice = response[3];

        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: result.data.success.barcode + " - " + result.data.success.productCode + " - " + result.data.success.name,
            idProduct: result.data.success.id,
            initialPriceHtc: result.data.salesprice.initialSellingPrice,
            quantity: 1,
            tva: result.data.success.tva,
            idLot: idLot,
            sellingPrice: sellingPrice,
            currency: deviseChoosen,
            currencyPrice: result.data.salesprice.initialSellingPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
          },
        ]);




      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });

  };

  const onChangeNamePackHandler = (event) => {
    setNamePack(event.target.value);
  };

  const onChangeStartDate = (event) => {
    setStartDate(event.target.value.concat(":59"));
  };
  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };
  return (
    <>
      <div class="modal fade" id="add-Pack">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Ajouter un pack</h4>
            </div>
            <div class="modal-body">
              <div className="row">


                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">Titre</label>
                    <input
                      value={namePack}
                      required="required"
                      onChange={onChangeNamePackHandler}
                      type="text"
                      id="inputClientCompany"
                      className="form-control"
                      placeholder="Saisir..."
                    />
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="inputName">Date début</label>

                    <TextField
                      style={{ width: "100%" }}
                      className="col-sm-12"
                      variant="outlined"
                      value={startDate}
                      onChange={onChangeStartDate}
                      id="datetime-local"
                      type="datetime-local"
                      defaultValue="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      size="small"
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="inputName">Date fin</label>

                    <TextField
                      style={{ width: "100%" }}
                      className="col-sm-12"
                      variant="outlined"
                      value={endDate}
                      onChange={onChangeEndDate}
                      id="datetime-local"
                      type="datetime-local"
                      defaultValue="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      size="small"
                    />
                  </div>
                </div>
              </div>



            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button type="button" onClick={onAddBrand} class="btn btn-light">
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      {open && <Snackbar
        open={openAlert}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddPackFactureModel;
